import client, { API_BASE_URL } from './client';

export async function getProductList(params) {
  const res = await client.get('/admin/product', { params });
  return res.data;
}

export async function getProduct(productId) {
  const res = await client.get(`/admin/product/${productId}`);
  return res.data;
}

export async function createProduct(payload) {
  const res = await client.post('/admin/product', payload);
  return res.data;
}

export async function updateProduct(productId, payload) {
  const res = await client.put(`/admin/product/${productId}`, payload);
  return res.data;
}

export async function deleteProduct(productId) {
  const res = await client.delete(`/admin/product/${productId}`);
  return res.data;
}

export async function stopSale(productId, updatedBy) {
  const res = await client.put(`/admin/product/${productId}/stop-sale`, null, { params: { updatedBy } });
  return res.data;
}

export async function resumeSale(productId, updatedBy) {
  const res = await client.put(`/admin/product/${productId}/resume-sale`, null, { params: { updatedBy } });
  return res.data;
}

/** 드래그앤드롭으로 바뀐 노출순서 저장 */
export async function reorderProducts(orderedProductIds, updatedBy) {
  const res = await client.put('/admin/product/reorder', { orderedProductIds, updatedBy });
  return res.data;
}

/** 추천메뉴 지정/해제 - QR오더 메뉴 화면 상단 "추천 메뉴" 섹션 노출 여부 */
export async function updateProductRecommend(productId, recommendYn, updatedBy) {
  const res = await client.put(`/admin/product/${productId}/recommend`, null, { params: { recommendYn, updatedBy } });
  return res.data;
}

// ===================== 이미지 =====================
// 상품 이미지는 고객 노출용이라 인증 없이 열람 가능하도록 백엔드에서 열어뒀다.
// 그래서 공지사항 첨부파일과 달리 blob 다운로드 트릭 없이 <img src> 로 바로 사용할 수 있다.

export function getMainImageUrl(productId) {
  return `${API_BASE_URL}/admin/product/${productId}/image/main`;
}

export function getThumbnailImageUrl(productId) {
  return `${API_BASE_URL}/admin/product/${productId}/image/thumbnail`;
}

export function getDetailImageUrl(detailImageId) {
  return `${API_BASE_URL}/admin/product/detail-image/${detailImageId}/view`;
}

export async function uploadMainImage(productId, file, updatedBy) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('updatedBy', updatedBy);
  const res = await client.post(`/admin/product/${productId}/image/main`, formData);
  return res.data;
}

export async function uploadThumbnailImage(productId, file, updatedBy) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('updatedBy', updatedBy);
  const res = await client.post(`/admin/product/${productId}/image/thumbnail`, formData);
  return res.data;
}

export async function uploadDetailImages(productId, files, createdBy) {
  const formData = new FormData();
  files.forEach((f) => formData.append('files', f));
  formData.append('createdBy', createdBy);
  const res = await client.post(`/admin/product/${productId}/image/detail`, formData);
  return res.data;
}

export async function deleteDetailImage(detailImageId) {
  const res = await client.delete(`/admin/product/detail-image/${detailImageId}`);
  return res.data;
}

// ===================== 재고 (Redis 실시간) =====================
// 아직 주문 모듈이 없어 시뮬레이션용으로 제공되는 API. 실제 판매/취소는 주문 모듈이
// 백엔드의 ProductStockService 를 직접 호출하도록 연동하면 된다.

export async function getStock(optionId) {
  const res = await client.get(`/admin/product/option/${optionId}/stock`);
  return res.data;
}

export async function simulateSale(optionId, qty, updatedBy) {
  const res = await client.post(`/admin/product/option/${optionId}/simulate-sale`, null, { params: { qty, updatedBy } });
  return res.data;
}

export async function simulateCancel(optionId, qty, updatedBy) {
  const res = await client.post(`/admin/product/option/${optionId}/simulate-cancel`, null, { params: { qty, updatedBy } });
  return res.data;
}

/** 실재고와 무관하게 옵션을 즉시 품절 처리한다. */
export async function markOptionSoldOut(optionId, updatedBy) {
  const res = await client.put(`/admin/product/option/${optionId}/sold-out`, null, { params: { updatedBy } });
  return res.data;
}

/** 옵션 품절 수동처리를 해제한다. */
export async function markOptionAvailable(optionId, updatedBy) {
  const res = await client.put(`/admin/product/option/${optionId}/available`, null, { params: { updatedBy } });
  return res.data;
}

// ===================== 옵션 이미지 =====================
// 옵션 이미지도 상품 이미지와 동일하게 인증 없이 열람 가능하다.

export function getOptionImageUrl(optionId) {
  return `${API_BASE_URL}/admin/product/option/${optionId}/image`;
}

export async function uploadOptionImage(optionId, file, updatedBy) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('updatedBy', updatedBy);
  const res = await client.post(`/admin/product/option/${optionId}/image`, formData);
  return res.data;
}

// ===================== 기간별 할인 =====================

export async function getDiscountHistory(productId) {
  const res = await client.get(`/admin/product/${productId}/discount`);
  return res.data;
}

export async function createDiscount(productId, payload) {
  const res = await client.post(`/admin/product/${productId}/discount`, payload);
  return res.data;
}

export async function updateDiscount(discountId, payload) {
  const res = await client.put(`/admin/product/discount/${discountId}`, payload);
  return res.data;
}

export async function deleteDiscount(discountId) {
  const res = await client.delete(`/admin/product/discount/${discountId}`);
  return res.data;
}

// ===================== 다국어 메뉴판 (번역) =====================
// QR오더 다국어 메뉴판 - 상품별 언어(EN/JA/ZH)별 번역 관리.

export async function getTranslationList(productId) {
  const res = await client.get(`/admin/product/${productId}/translation`);
  return res.data;
}

/** langCode 조합이 이미 있으면 수정, 없으면 신규 등록(upsert) */
export async function upsertTranslation(productId, langCode, payload, updatedBy) {
  const res = await client.put(`/admin/product/${productId}/translation/${langCode}`, payload, { params: { updatedBy } });
  return res.data;
}

export async function deleteTranslation(translationId) {
  const res = await client.delete(`/admin/product/translation/${translationId}`);
  return res.data;
}

// ===================== 사이드 메뉴 제안 (업셀) =====================
// 레퍼런스 "사이드 메뉴 제안으로 객단가가 상승해요" 벤치마킹 - 이 상품을 담을 때
// 함께 제안할 사이드 상품을 등록/삭제한다.

export async function getSideRecommendList(productId) {
  const res = await client.get(`/admin/product/${productId}/side-recommend`);
  return res.data;
}

export async function addSideRecommend(productId, sideProductId, updatedBy) {
  const res = await client.post(`/admin/product/${productId}/side-recommend`, { sideProductId }, { params: { updatedBy } });
  return res.data;
}

export async function deleteSideRecommend(sideRecommendId) {
  const res = await client.delete(`/admin/product/side-recommend/${sideRecommendId}`);
  return res.data;
}
